<template>
  <div class="warp">
    <div id="app">
      <router-view v-if="isRouterAlive" />
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style>
@keyframes monitorLoading1 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes monitorLoading2 {
  from {
    transform: rotateY(0deg);
  }
  to {
    transform: rotateY(360deg);
  }
}
* {
  touch-action: none;
}
body {
  margin: 0;
  background: #fff;
  overflow: hidden;
}
#app {
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.warp {
  min-width: 1200px;
  min-width: 600px;
  height: 100%;
  position: relative;
}
p {
  color: #303133;
  font-size: 14px;
}
.p-index .p-index-tabs .el-tabs__content {
  display: none;
}
.p-index-tabs {
  width: 180px;
}
.p-index .p-index-tabs .el-tabs__header {
  float: right;
  margin: 0 2px 0 0;
  padding: 0;
}

.p-index .p-index-tabs .el-tabs__nav-wrap::after {
  background: 0;
}
.p-index .el-input-group__append button.el-button {
  background-color: #409eff;
  color: #fff;
  border-radius: 0 2px 2px 0;
  border: 1px solid #409eff;
}

.g-skill-1,
.g-skill-2,
.g-skill-3,
.g-skill-4,
.g-skill-5 {
  background-color: #ecf5ff;
  display: inline-block;
  height: 26px;
  padding: 0 10px;
  line-height: 24px;
  font-size: 12px;
  color: #409eff;
  border: 1px solid #d9ecff;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  margin-right: 4px;
}
.g-skill-2 {
  background-color: #f0f9eb;
  border-color: #e1f3d8;
  color: #67c23a;
}
.g-skill-3 {
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
}
.g-skill-4 {
  background-color: #fdf6ec;
  border-color: #faecd8;
  color: #e6a23c;
}
.g-skill-5 {
  background-color: #fdf6ec;
  border-color: #faecd8;
  color: #e6a23c;
}
.g-status-1 {
  color: #00a854;
}
.g-status-2 {
  color: #d06561;
}

/*禁用video的controls（要慎重！不要轻易隐藏掉，会导致点击视频不能播放）*/
video::-webkit-media-controls {
  /* display: none !important; */
}

.p-live .ant-notification-notice-close,
.p-event .ant-notification-notice-close {
  right: 10px !important;
  color: #fff !important;
}

@keyframes load3 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* .p-live .ant-notification,
.p-event .ant-notification {
  margin: 0 !important;
  width: auto !important;
}
.p-live .ant-notification-notice.ant-notification-notice-closable,
.p-event .ant-notification-notice.ant-notification-notice-closable {
  background: rgba(255, 0, 85, 0.8) !important;
  border-radius: 16px 0 0 16px !important;
  padding: 4px 10px !important;
}
.p-live .ant-btn.ant-btn-link.ant-btn-sm,
.p-live .ant-notification-notice-btn,
.p-event .ant-btn.ant-btn-link.ant-btn-sm,
.p-event .ant-notification-notice-btn {
  line-height: 40px !important;
  height: 40px !important;
  color: #fff !important;
  font-size: 20px !important;
  font-weight: bold !important;
  padding: 0 10px 0 22px !important;
  margin: 0 !important;
}
.p-live .ant-notification-notice-btn,
.p-event .ant-notification-notice-btn {
  background: url(https://p5.ssl.qhimg.com/t01d7fa69f8d092c7c0.png) no-repeat
    4px center;
  background-size: 32px 30px;
}

.p-live .ant-notification-notice-message,
.p-event .ant-notification-notice-message {
  display: none !important;
} */
/* 公共样式 */
button,
input,
select {
  border-radius: 0 !important;
}
.ant-switch {
  border-radius: 100px !important;
}
.ant-switch-checked {
  background-color: #006bff !important;
}
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #006bff !important;
  border-color: #006bff !important;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  border-color: #006bff !important;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #006bff !important;
}
.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background-color: #006bff !important;
}
.ant-btn-primary {
  background: #006bff !important;
  border: 1px solid #006bff !important;
  border-radius: 0 !important;
}
.ant-btn-primary:hover {
  background: #0056cf !important;
  border: 1px solid #006bff !important;
}
.ant-input,
.ant-select-selection {
  border-radius: 0 !important;
}
.ant-table table {
  border-radius: 0 !important;
  border-top: 1px solid #ebeff8 !important;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 16px 20px !important;
}
.ant-table-thead > tr > th {
  background: #fbfbfc !important;
  border-bottom: 1px solid #ebeff8 !important;
}
.ant-table-thead
  > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  > td,
.ant-table-tbody
  > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  > td,
.ant-table-thead
  > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  > td,
.ant-table-tbody
  > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  > td {
  background: #f2f7ff !important;
}
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  border-radius: 0 !important;
}
.ant-pagination-item {
  border-radius: 0 !important;
}
.ant-pagination-item-active {
  border-color: #007aff !important;
  background: #007aff !important;
}
.ant-pagination-item-active a {
  color: #fff !important;
}
.ant-pagination-item:focus,
.ant-pagination-item:hover {
  border-color: #007aff !important;
  background: #007aff !important;
}
.ant-pagination-item:focus a,
.ant-pagination-item:hover a {
  color: #fff !important;
}
.ant-btn-primary:hover,
.ant-btn-primary:focus {
  color: #fff !important;
  background-color: #388bff !important;
  border-color: #388bff !important;
}
/* 删除提示窗 */
.ant-modal-content {
  border-radius: 0 !important;
}
.ant-modal-close-x {
  width: 44px !important;
  height: 44px !important;
  margin: 0 !important;
  color: #6e6e6e !important;
  font-size: 15px !important;
  line-height: 44px !important;
}
.ant-modal-header {
  padding: 0 20px !important;
  background: #fafafa !important;
  border-bottom: 1px solid #eff0f2 !important;
  height: 44px !important;
  line-height: 44px !important;
}
.ant-modal-title {
  line-height: 44px !important;
}
.ant-modal-body {
  padding: 30px 20px 40px !important;
}
.ant-modal-footer {
  padding: 10px 20px !important;
  border-top: 1px solid #eff0f2 !important;
}
.ant-modal-footer .ant-btn {
  border-radius: 0 !important;
}
.ant-modal-footer button + button {
  margin-left: 10px !important;
}

.el-input--small .el-input__inner {
  border-radius: 0 !important;
}
/* 提示信息 */
.ant-alert-warning {
  border: none !important;
  background: #fcf7f1 !important;
  border-radius: 0 !important;
  /* height: 34px !important; */
  line-height: 34px !important;
  padding: 0 10px 0 30px !important;
}
.ant-alert-icon {
  position: absolute !important;
  top: 10px !important;
  left: 10px !important;
}
.el-message--success .el-message__content {
  color: #333 !important;
}
.el-message-box {
  padding-bottom: 20px !important;
  border-radius: 0 !important;
}
.el-message-box .el-message-box__content {
  padding: 20px 15px !important;
}
.el-message-box__btns {
  padding: 5px 20px 0 !important;
  text-align: right !important;
}
.el-message-box__btns button {
  min-width: 88px !important;
  border-radius: 0 !important;
}
.el-del-box .el-button:hover {
  color: #096dd9 !important;
  background-color: #fff !important;
  border-color: #096dd9 !important;
}
.el-del-box .el-button--primary {
  background: #f84e44 !important;
  border: 1px solid #f84e44 !important;
}
.el-del-box .el-button--primary:hover {
  background: #f84e44 !important;
  border: 1px solid #f84e44 !important;
  color: #fff !important;
}
.ant-radio-inner::after {
  background-color: #007aff !important;
}
.ant-radio-checked .ant-radio-inner {
  border-color: #007aff !important;
}
.el-input.is-disabled .el-input__inner {
  background-color: #f7f7f7 !important;
  border-color: #dbdbdb !important;
  color: #c7c7c7 !important;
}
.ant-btn.disabled,
.ant-btn[disabled] {
  background: #d9d9d9 !important;
  border: 1px solid #d9d9d9 !important;
}
.ant-btn.disabled:hover,
.ant-btn[disabled]:hover {
  color: #aaa !important;
  border-color: #d9d9d9 !important;
  background: #d9d9d9 !important;
}
.sdk-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%);
}
.monitor-loading1 {
  position: absolute;
  top: 50%;
  left: 50%;
  display: inline-block;
  width: 100px;
  height: 100px;
  margin: -50px 0 0 -50px;
  background: url(https://p4.ssl.qhimg.com/t01f52722a40704e868.png) no-repeat
    center;
  background-size: 100% 100%;
  animation: monitorLoading1 3s linear infinite;
}
.monitor-loading2 {
  position: absolute;
  top: 50%;
  left: 50%;
  display: inline-block;
  width: 60px;
  height: 60px;
  margin: -30px 0 0 -30px;
  background: url(https://p5.ssl.qhimg.com/t0174ffd5bba1e320af.png) no-repeat
    center;
  background-size: 100% 100%;
  animation: monitorLoading2 2.5s linear infinite;
}
</style>



// WEBPACK FOOTER //
// src/App.vue